/**
 * Created by katarinababic on 6.11.24.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useRootStore } from '../../Store/useRootStore';
import { useParams } from 'react-router-dom';
import { ExploreContentViewRenderer } from '../../Components/EntryView/ExploreContentViewRenderer';
import { ExploreContentBuilder, KinasticContent } from '../../Model/Explore/ExploreContentBuilder';
import { ExploreCategory } from '../../Model/Explore/ExploreCategory';
import { Container } from 'reactstrap';
import { ExploreContentViewCategoryRenderer } from '../Academy/View/CategoryView/ExploreContentViewCategoryRenderer';
import { RelatedEntriesView } from '../../Components/RelatedEntriesView';
import { ContentNotFound } from '../../Components/EntryView/ContentNotFound';

export type NutritionContentViewScreenProps = {};

export const NutritionContentViewScreen: React.FC<NutritionContentViewScreenProps> = observer((props) => {
  const { analytics } = useRootStore();

  const [content, setContent] = useState<KinasticContent | undefined>();
  const [lastError, setLastError] = useState<unknown>(undefined);
  const [loading, setLoading] = useState(true);
  const { contentId } = useParams<{ contentId: string }>();

  useEffect(() => {
    setContent(undefined);
    setLastError(undefined);
    if (contentId) {
      setLoading(true);
      ExploreContentBuilder.findOne(contentId)
        .then((res) => setContent(res))
        .catch((e: unknown) => setLastError(e))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [contentId]);

  useEffect(() => {
    if (content) {
      const type = content.type === 'recipe' ? 'recipe' : content.type;
      analytics.logSelectContent(type, content.id);
    }
  }, [analytics, content]);

  if (content) {
    if ('contentType' in content && content.contentType === 'category' && 'identifier' in content) {
      return (
        <Container>
          <ExploreContentViewCategoryRenderer category={content as ExploreCategory} linkPrefix={'/nutrition/'} />
        </Container>
      );
    }
    const exploreEntry = 'backgroundImage' in content ? content : undefined;
    return (
      <React.Fragment>
        <ExploreContentViewRenderer entry={content} />
        {exploreEntry && <RelatedEntriesView entry={exploreEntry} linkPrefix={'/nutrition/'} />}
      </React.Fragment>
    );
  }

  if (loading) {
    return <Container style={{ padding: '48px', textAlign: 'center' }}>Loading...</Container>;
  }

  return lastError ? <ContentNotFound /> : null;
});
